import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { DetailedQuote } from '../../../../../domain/public-api';
import { QuoteIssueType } from '../../domain';
import { QuoteVolumeContextualHelpComponent } from '../../quote-volume/quote-volume-contextual-help.component';
import { ListComponent } from '../../../../../components/list/list.component';
import { ListItemComponent } from '../../../../../components/list/list-item.component';
import { ListItemValueComponent } from '../../../../../components/list/list-item-value.component';
import { ListItemLabelComponent } from '../../../../../components/list/list-item-label.component';
import { NumberPipe } from '../../../../../pipes/number.pipe';
import { CurrencyPipe } from '../../../../../pipes/currency.pipe';
import { DetailedQuoteSummarySymbolDetailComponent } from './detailed-quote-summary-symbol-detail.component';

@Component({
  selector: 'td-wb-detailed-quote-summary',
  templateUrl: './detailed-quote-summary.component.html',
  styleUrls: ['./detailed-quote-summary.component.scss'],
  imports: [
    NgTemplateOutlet,
    TranslateDirective,
    ListComponent,
    DetailedQuoteSummarySymbolDetailComponent,
    ListItemComponent,
    ListItemValueComponent,
    ListItemLabelComponent,
    CurrencyPipe,
    NumberPipe,
    QuoteVolumeContextualHelpComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailedQuoteSummaryComponent implements OnChanges {

  @Input() quote: DetailedQuote;

  @ViewChild('stock', { static: true }) templateRefStock: TemplateRef<unknown>;
  @ViewChild('index', { static: true }) templateRefIndex: TemplateRef<unknown>;
  @ViewChild('mf', { static: true }) templateRefMf: TemplateRef<unknown>;
  @ViewChild('option', { static: true }) templateRefOption: TemplateRef<unknown>;
  @ViewChild('etf', { static: true }) templateRefEtf: TemplateRef<unknown>;

  currentTemplate: TemplateRef<unknown>;
  readonly placeholder: string = '\u2014';
  /**
   * Set template on quote changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['quote'];
    if (change !== undefined) {
      this.currentTemplate = this.getIssueTypeTemplate();
    }
  }

  /**
   * get template based on issue type
   *
   * @returns template to be used in template outlet
   */
  private getIssueTypeTemplate(): TemplateRef<unknown> | undefined {
    switch (this.quote.issueType) {
      case QuoteIssueType.STOCK:
        return this.templateRefStock;
      case QuoteIssueType.ETF:
        return this.templateRefEtf;
      case QuoteIssueType.INDEX:
        return this.templateRefIndex;
      case QuoteIssueType.OPTION:
        return this.templateRefOption;
      case QuoteIssueType.MF:
        return this.templateRefMf;
      default:
        return undefined;
    }
  }
}
